<div class="col-span-2">
  <a
    class="w-full flex flex-col items-start justify-center overflow-hidden p-4 pr-5 cursor-pointer gap-0.5"
    [class.rounded-sm]="rounded === 'small'"
    [class.rounded-md]="rounded === 'medium'"
    [class.rounded-lg]="!rounded || rounded === 'large'"
    [class.rounded-2xl]="rounded === '2xl'"
    [class.rounded-3xl]="rounded === '3xl'"
    [class.rounded-4xl]="rounded === '4xl'"
    [class.rounded-full]="rounded === 'full'"
    [class.shadow-S]="!shadow || shadow === 'small'"
    [class.shadow-md]="shadow === 'medium'"
    [class.shadow-lg]="shadow === 'large'"
    [style.aspect-ratio]="aspectRatio"
    [style.backgroundColor]="backgroundColor | contentBuilderColor: '#E6BE2A'"
  >
    <h2
      class="font-accent text-sm md:text-base font-semibold"
      [style.color]="textColor | contentBuilderColor: 'neutral-800'"
    >
      {{ heading | translate }}
    </h2>
    <p
      class="font-base text-sm md:text-base font-light"
      [style.color]="textColor | contentBuilderColor: 'neutral-800'"
    >
      {{ text | translate }}
    </p>
  </a>
</div>
